var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div data-bind="css: cssClasses"> <div class="container"><!-- ko if: template --> <div data-bind="template: template"></div><!-- /ko --><!-- ko if: component --> <div data-bind="component: component"></div><!-- /ko --> </div> </div>';
}
return __p;
};
